export class TypeLeurre {
    static jsonMap = {
        id: 'id',
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    id: number;
    code: string;
    libelle: string;
}
